export default __webpack_public_path__ + "static/5-23d9444e9dfd41528afc94f499f85697.jpg";